// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/utils.scss";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3UtNB4qPx{margin-bottom:20px}._1HQ1KbcRx{margin-bottom:20px;background-color:var(--banner-blue)}._72KlOPELx{flex:1}._72KlOPELx ._1ZbrINomx{flex:0 0 auto;align-self:flex-start;margin-right:20px}._72KlOPELx ._1eclorQYx{flex:1 0 60%;margin-right:8px}._72KlOPELx ._6ScyvFZsx{font-size:20px;margin-bottom:7px}._72KlOPELx ._3qecWjtZx{max-width:620px;font-size:14px}._72KlOPELx ._6gbONZ2Lx{flex:0 0 auto;cursor:pointer;align-self:flex-end;margin-left:8px}._72KlOPELx .ItvuNLefx{color:var(--link-text);margin-left:4px;text-decoration:none}._6Ek2uXe0x,._22hrDREax{opacity:0.01;max-height:0}._6Ek2uXe0x._7AxMNDHvx,._22hrDREax._6aKruAGfx{opacity:1;max-height:500px;transition:max-height .7s,opacity .7s}._5Tcuqj7lx{opacity:1;max-height:500px}._5Tcuqj7lx.d6dHKUdUx{opacity:0;max-height:0;transition:max-height .7s,opacity .7s}\n", "",{"version":3,"sources":["webpack://client/shared/info-banner/info-banner.scss"],"names":[],"mappings":"AAAwmB,YAAa,kBAAkB,CAAC,YAAa,kBAAkB,CAAC,mCAAmC,CAAC,YAA8D,MAAM,CAAC,wBAAkB,aAAa,CAAC,qBAAqB,CAAC,iBAAiB,CAAC,wBAAoB,YAAY,CAAC,gBAAgB,CAAC,wBAAkB,cAAc,CAAC,iBAAiB,CAAC,wBAAwB,eAAe,CAAC,cAAc,CAAC,wBAAiB,aAAa,CAAC,cAAc,CAAC,mBAAmB,CAAC,eAAe,CAAC,uBAAsB,sBAAsB,CAAC,eAAe,CAAC,oBAAoB,CAAC,wBAAe,YAAY,CAAC,YAAY,CAAC,8CAA0C,SAAS,CAAC,gBAAgB,CAAC,qCAAqC,CAAC,YAAO,SAAS,CAAC,gBAAgB,CAAC,sBAAoB,SAAS,CAAC,YAAY,CAAC,qCAAqC","sourcesContent":[":export{tabletScreen:768px;smallScreen:1100px;mediumScreen:1300px;largeScreen:1500px;azure:#006fc8;cyan:#1FAECE;primaryText:var(--primary-text);secondaryText:var(--secondary-text);chartGridColor:var(--ui-divider);gray10:#dedede;msDarkBlue:#002050;amberLight2:#F7E28B;violetLight2:#CEC0EC;tealLight3:#CFECE8;bannerBlue:var(--banner-blue);spaceXXS:4px;spaceXS:8px;spaceS:16px;spaceM:20px;spaceXM:24px;spaceL:32px;spaceXL:40px;spaceXXL:60px;panelSlideDuration:200ms;panelFadeDuration:100ms;ccBannerHeight:46px;chartCyan:var(--charts-cyan);chartMapBorders:var(--charts-map-border);chartMapBgDefault:var(--charts-map-bg)}.info-banner{margin-bottom:20px}.blue-banner{margin-bottom:20px;background-color:var(--banner-blue)}.container{composes:vertically-center from '~@css/utils.scss';flex:1}.container .image{flex:0 0 auto;align-self:flex-start;margin-right:20px}.container .content{flex:1 0 60%;margin-right:8px}.container .title{font-size:20px;margin-bottom:7px}.container .description{max-width:620px;font-size:14px}.container .link{flex:0 0 auto;cursor:pointer;align-self:flex-end;margin-left:8px}.container .hyperlink{color:var(--link-text);margin-left:4px;text-decoration:none}.enter,.appear{opacity:0.01;max-height:0}.enter.enter-active,.appear.appear-active{opacity:1;max-height:500px;transition:max-height .7s,opacity .7s}.leave{opacity:1;max-height:500px}.leave.leave-active{opacity:0;max-height:0;transition:max-height .7s,opacity .7s}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"info-banner": "_3UtNB4qPx",
	"infoBanner": "_3UtNB4qPx",
	"blue-banner": "_1HQ1KbcRx",
	"blueBanner": "_1HQ1KbcRx",
	"container": "_72KlOPELx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["vertically-center"] + "",
	"image": "_1ZbrINomx",
	"content": "_1eclorQYx",
	"title": "_6ScyvFZsx",
	"description": "_3qecWjtZx",
	"link": "_6gbONZ2Lx",
	"hyperlink": "ItvuNLefx",
	"enter": "_6Ek2uXe0x",
	"appear": "_22hrDREax",
	"enter-active": "_7AxMNDHvx",
	"enterActive": "_7AxMNDHvx",
	"appear-active": "_6aKruAGfx",
	"appearActive": "_6aKruAGfx",
	"leave": "_5Tcuqj7lx",
	"leave-active": "d6dHKUdUx",
	"leaveActive": "d6dHKUdUx"
};
export default ___CSS_LOADER_EXPORT___;
